import { MultiFilter } from '@pages/Clients/NewClientsList/components';
import { VISIT_ROWS } from '@pages/Clients/NewClientsList/data/rows';

import type { FC } from 'react';

export const VisitFilter: FC<{ id: number; onClear: (id: number) => void }> = ({
  id,
  onClear,
}) => {
  return (
    <MultiFilter
      label="По визитам"
      selectedCount={0}
      rows={VISIT_ROWS}
      width={250}
      id={id}
      onClear={onClear}
    />
  );
};
